import { apiClient } from './apiClient';
import { debugLogger } from '../utils/debugLogger';
import { FriendRecommendation, FriendRecommendationsResponse } from '../types/recommendation';

class RecommendationService {
  private baseUrl = '/api/ai/recommendations';

  async getFriendRecommendations(userId: number, limit?: number): Promise<FriendRecommendation[]> {
    const endpoint = `${this.baseUrl}/friends/${userId}`;
    debugLogger.logApiCall('GET', endpoint, { userId, limit });
    
    try {
      const params = limit ? { limit } : {};
      const response = await apiClient.get<FriendRecommendationsResponse>(endpoint, {
        params
      });
      
      debugLogger.logApiResponse('GET', endpoint, response);
      
      // Extract the nested data array from response structure
      // response is FriendRecommendationsResponse, so response.data.data is FriendRecommendation[]
      const recommendations: FriendRecommendation[] = response?.data?.data || [];
      
      debugLogger.log('RecommendationService', `👥 Friend Recommendations API Success`, {
        endpoint,
        userId,
        limit,
        recommendationsCount: recommendations.length,
        recommendations: recommendations.map((rec: FriendRecommendation) => ({
          userId: rec.user_id,
          displayName: rec.display_name,
          score: rec.score,
          reasonsCount: rec.reasons.length
        }))
      });
      
      return recommendations;
    } catch (error) {
      debugLogger.logApiResponse('GET', endpoint, null, error);
      debugLogger.log('RecommendationService', `❌ Friend Recommendations API Error`, {
        endpoint,
        userId,
        limit,
        error: error instanceof Error ? error.message : 'Unknown error'
      });
      throw error;
    }
  }
}

export const recommendationService = new RecommendationService();

